<template>
  <div :style="{ width }">
    <CImg
            v-if="localValue && !localValue['fileName']"
            :src="localValue"
            block
            class="mb-2"
            style="max-height: 200px"
    />
    <ValidationProvider v-slot="{ errors }" :rules="rules" :name="label" :vid="name">
      <input
        v-if="localValue && localValue.fileName"
        v-model="localValue.fileName"
        type="hidden"
        ref="hidden"
      />
      <v-file-input
        class="file-field"
        filled
        :error-messages="errors[0]"
        :name="name"
        :loading="uploading"
        @change="onFileChanged"
        :placeholder="localValue ? localValue['fileName'] : ''"
        @click:clear="onRemove"
        :accept="accept"
      >
        <!-- :placeholder="storedFile" -->
      </v-file-input>
    </ValidationProvider>
  </div>
</template>

<script>
import axios from "@/axios";

export default {
  props: {
    value: {
      default: null
    },
    name: {
      type: String
    },
    label: {
      type: String
    },
    rules: {
      type: [String, Object],
      default: ""
    },
    errorMessages: {
      type: Array
    },
    // TODO: 削除検討
    displayStoredFile: {
      type: Boolean,
      default: false
    },
    storedFile: {
      type: String,
      default: ""
    },
    width: {
      type: String,
      default: "300px"
    },
    accept: {
      type: String,
      default: "image/*"
    }
  },
  data() {
    return {
      uploading: false,
      fileName: ""
    };
  },
  computed: {
    localValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    }
  },
  methods: {
    onFileChanged(file) {
      if (file) {
        this.uploading = true;
        let formData = new FormData();
        formData.append("file", file);

        axios
          .postUpload("file", formData)
          .then(response => {
            if (response.data) {
              this.localValue = {
                ...response.data.data
              };
            }
            this.uploading = false;
          })
          .catch(() => {
            this.uploading = false;
          });
      }
    },
    onRemove() {
      this.fileName = "";
      this.localValue = null;

      // this.$refs.hidden.value = "";

      // this.$nextTick().then(() => {
      //   this.$validator.validate(this.name);
      // });
    }
  }
};
</script>

<style module lang="scss"></style>
